/* tslint:disable */
/* eslint-disable */
/**
 * Hisselab.Profile.Query
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @enum {string}
 */

export const Amount = {
    NotSpecify: 'NotSpecify',
    UnderMillion: 'UnderMillion',
    MillionBetween: 'MillionBetween',
    Over10Million: 'Over10Million',
    Empty: 'Empty'
} as const;

export type Amount = typeof Amount[keyof typeof Amount];


/**
 * 
 * @export
 * @interface Any
 */
export interface Any {
    [key: string]: any;

    /**
     * 
     * @type {string}
     * @memberof Any
     */
    '@type': string;
}
/**
 * 
 * @export
 * @interface BasicUpdateReplay
 */
export interface BasicUpdateReplay {
    /**
     * 
     * @type {boolean}
     * @memberof BasicUpdateReplay
     */
    'status'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BasicUpdateReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface DefaultStockFetchReplay
 */
export interface DefaultStockFetchReplay {
    /**
     * 
     * @type {string}
     * @memberof DefaultStockFetchReplay
     */
    'securityCode'?: string;
    /**
     * 
     * @type {string}
     * @memberof DefaultStockFetchReplay
     */
    'entityId'?: string;
    /**
     * 
     * @type {string}
     * @memberof DefaultStockFetchReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const InterestedProducts = {
    Stock: 'Stock',
    StockAndDerivative: 'StockAndDerivative',
    ExchangeAndDerivative: 'ExchangeAndDerivative',
    EmptyField: 'EmptyField'
} as const;

export type InterestedProducts = typeof InterestedProducts[keyof typeof InterestedProducts];


/**
 * 
 * @export
 * @interface Profile
 */
export interface Profile {
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'surname'?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'birthday'?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'officephone'?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'mobilePhone'?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'country'?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'gender'?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'languagecode'?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'address'?: string;
    /**
     * 
     * @type {Amount}
     * @memberof Profile
     */
    'amount'?: Amount;
    /**
     * 
     * @type {Array<InterestedProducts>}
     * @memberof Profile
     */
    'interestedProducts'?: Array<InterestedProducts>;
    /**
     * 
     * @type {number}
     * @memberof Profile
     */
    'cityCode'?: number;
}


/**
 * 
 * @export
 * @interface ProfileReplay
 */
export interface ProfileReplay {
    /**
     * 
     * @type {Profile}
     * @memberof ProfileReplay
     */
    'profile'?: Profile;
    /**
     * 
     * @type {string}
     * @memberof ProfileReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface SetDefaultStockReplay
 */
export interface SetDefaultStockReplay {
    /**
     * 
     * @type {boolean}
     * @memberof SetDefaultStockReplay
     */
    'availableModifiedCount'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SetDefaultStockReplay
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface Status
 */
export interface Status {
    /**
     * 
     * @type {number}
     * @memberof Status
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof Status
     */
    'message'?: string;
    /**
     * 
     * @type {Array<Any>}
     * @memberof Status
     */
    'details'?: Array<Any>;
}

/**
 * ProfileServiceApi - axios parameter creator
 * @export
 */
export const ProfileServiceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [name] 
         * @param {string} [surname] 
         * @param {string} [birthday] 
         * @param {string} [officephone] 
         * @param {string} [mobilePhone] 
         * @param {string} [email] 
         * @param {string} [country] 
         * @param {string} [gender] 
         * @param {string} [languagecode] 
         * @param {string} [address] 
         * @param {Amount} [amount] 
         * @param {Array<InterestedProducts>} [interestedProducts] 
         * @param {number} [cityCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileBasicUpdateGet: async (identityToken: string, name?: string, surname?: string, birthday?: string, officephone?: string, mobilePhone?: string, email?: string, country?: string, gender?: string, languagecode?: string, address?: string, amount?: Amount, interestedProducts?: Array<InterestedProducts>, cityCode?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('profileBasicUpdateGet', 'identityToken', identityToken)
            const localVarPath = `/profile/basicUpdate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (surname !== undefined) {
                localVarQueryParameter['surname'] = surname;
            }

            if (birthday !== undefined) {
                localVarQueryParameter['birthday'] = birthday;
            }

            if (officephone !== undefined) {
                localVarQueryParameter['officephone'] = officephone;
            }

            if (mobilePhone !== undefined) {
                localVarQueryParameter['mobilePhone'] = mobilePhone;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (gender !== undefined) {
                localVarQueryParameter['gender'] = gender;
            }

            if (languagecode !== undefined) {
                localVarQueryParameter['languagecode'] = languagecode;
            }

            if (address !== undefined) {
                localVarQueryParameter['address'] = address;
            }

            if (amount !== undefined) {
                localVarQueryParameter['amount'] = amount;
            }

            if (interestedProducts) {
                localVarQueryParameter['interestedProducts'] = interestedProducts;
            }

            if (cityCode !== undefined) {
                localVarQueryParameter['cityCode'] = cityCode;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileBasicprofiledetailGet: async (identityToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('profileBasicprofiledetailGet', 'identityToken', identityToken)
            const localVarPath = `/profile/basicprofiledetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileFetchstockGet: async (identityToken: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('profileFetchstockGet', 'identityToken', identityToken)
            const localVarPath = `/profile/fetchstock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entitiyId] 
         * @param {string} [securityCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileSetstockGet: async (identityToken: string, entitiyId?: string, securityCode?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('profileSetstockGet', 'identityToken', identityToken)
            const localVarPath = `/profile/setstock`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (entitiyId !== undefined) {
                localVarQueryParameter['entitiyId'] = entitiyId;
            }

            if (securityCode !== undefined) {
                localVarQueryParameter['securityCode'] = securityCode;
            }

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfileServiceApi - functional programming interface
 * @export
 */
export const ProfileServiceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfileServiceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [name] 
         * @param {string} [surname] 
         * @param {string} [birthday] 
         * @param {string} [officephone] 
         * @param {string} [mobilePhone] 
         * @param {string} [email] 
         * @param {string} [country] 
         * @param {string} [gender] 
         * @param {string} [languagecode] 
         * @param {string} [address] 
         * @param {Amount} [amount] 
         * @param {Array<InterestedProducts>} [interestedProducts] 
         * @param {number} [cityCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileBasicUpdateGet(identityToken: string, name?: string, surname?: string, birthday?: string, officephone?: string, mobilePhone?: string, email?: string, country?: string, gender?: string, languagecode?: string, address?: string, amount?: Amount, interestedProducts?: Array<InterestedProducts>, cityCode?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BasicUpdateReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileBasicUpdateGet(identityToken, name, surname, birthday, officephone, mobilePhone, email, country, gender, languagecode, address, amount, interestedProducts, cityCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileBasicprofiledetailGet(identityToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileBasicprofiledetailGet(identityToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileFetchstockGet(identityToken: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultStockFetchReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileFetchstockGet(identityToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entitiyId] 
         * @param {string} [securityCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async profileSetstockGet(identityToken: string, entitiyId?: string, securityCode?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetDefaultStockReplay>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.profileSetstockGet(identityToken, entitiyId, securityCode, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProfileServiceApi - factory interface
 * @export
 */
export const ProfileServiceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfileServiceApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [name] 
         * @param {string} [surname] 
         * @param {string} [birthday] 
         * @param {string} [officephone] 
         * @param {string} [mobilePhone] 
         * @param {string} [email] 
         * @param {string} [country] 
         * @param {string} [gender] 
         * @param {string} [languagecode] 
         * @param {string} [address] 
         * @param {Amount} [amount] 
         * @param {Array<InterestedProducts>} [interestedProducts] 
         * @param {number} [cityCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileBasicUpdateGet(identityToken: string, name?: string, surname?: string, birthday?: string, officephone?: string, mobilePhone?: string, email?: string, country?: string, gender?: string, languagecode?: string, address?: string, amount?: Amount, interestedProducts?: Array<InterestedProducts>, cityCode?: number, options?: any): AxiosPromise<BasicUpdateReplay> {
            return localVarFp.profileBasicUpdateGet(identityToken, name, surname, birthday, officephone, mobilePhone, email, country, gender, languagecode, address, amount, interestedProducts, cityCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileBasicprofiledetailGet(identityToken: string, options?: any): AxiosPromise<ProfileReplay> {
            return localVarFp.profileBasicprofiledetailGet(identityToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileFetchstockGet(identityToken: string, options?: any): AxiosPromise<DefaultStockFetchReplay> {
            return localVarFp.profileFetchstockGet(identityToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} identityToken 
         * @param {string} [entitiyId] 
         * @param {string} [securityCode] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        profileSetstockGet(identityToken: string, entitiyId?: string, securityCode?: string, options?: any): AxiosPromise<SetDefaultStockReplay> {
            return localVarFp.profileSetstockGet(identityToken, entitiyId, securityCode, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProfileServiceApi - object-oriented interface
 * @export
 * @class ProfileServiceApi
 * @extends {BaseAPI}
 */
export class ProfileServiceApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {string} [name] 
     * @param {string} [surname] 
     * @param {string} [birthday] 
     * @param {string} [officephone] 
     * @param {string} [mobilePhone] 
     * @param {string} [email] 
     * @param {string} [country] 
     * @param {string} [gender] 
     * @param {string} [languagecode] 
     * @param {string} [address] 
     * @param {Amount} [amount] 
     * @param {Array<InterestedProducts>} [interestedProducts] 
     * @param {number} [cityCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileServiceApi
     */
    public profileBasicUpdateGet(identityToken: string, name?: string, surname?: string, birthday?: string, officephone?: string, mobilePhone?: string, email?: string, country?: string, gender?: string, languagecode?: string, address?: string, amount?: Amount, interestedProducts?: Array<InterestedProducts>, cityCode?: number, options?: AxiosRequestConfig) {
        return ProfileServiceApiFp(this.configuration).profileBasicUpdateGet(identityToken, name, surname, birthday, officephone, mobilePhone, email, country, gender, languagecode, address, amount, interestedProducts, cityCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileServiceApi
     */
    public profileBasicprofiledetailGet(identityToken: string, options?: AxiosRequestConfig) {
        return ProfileServiceApiFp(this.configuration).profileBasicprofiledetailGet(identityToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileServiceApi
     */
    public profileFetchstockGet(identityToken: string, options?: AxiosRequestConfig) {
        return ProfileServiceApiFp(this.configuration).profileFetchstockGet(identityToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} identityToken 
     * @param {string} [entitiyId] 
     * @param {string} [securityCode] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfileServiceApi
     */
    public profileSetstockGet(identityToken: string, entitiyId?: string, securityCode?: string, options?: AxiosRequestConfig) {
        return ProfileServiceApiFp(this.configuration).profileSetstockGet(identityToken, entitiyId, securityCode, options).then((request) => request(this.axios, this.basePath));
    }
}



